<template>
    <div class="jh-container">
        <div class="jh-ui-header">
            <h1>금칙어관리</h1>
            <div class="is-right">
            </div>
        </div>
        <v-form class="jh-search-form" ref="form" v-model="isFormValid" lazy-validation>
            <table>
                <colgroup>
                    <col width="55px">
                    <col width="200px">
                    <col width="80px">
                    <col width="100px">
                    <col>
                </colgroup>
                <tr>
                    <th><label>보험사</label></th>
                    <td><v-text-field class="jh-form" name="name" id="id" v-model="formSearchData.SEARCH_PROH_WORD" v-on:keyup.enter="result()"></v-text-field></td>
                    <th><label>사용여부</label></th>
                    <td>
                        <v-select class="jh-form" :items="useYnDrop" v-model="formSearchData.USE_YN"></v-select>
                    </td>
                    <td class="has-search" @click="result"><v-btn class="jh-btn is-search">조회</v-btn></td>
                </tr>
            </table>
        </v-form>

        <div class="jh-form-wrap">
            <div class="jh-ui-header">
                <h2>금칙어현황</h2>
                <div class="is-right">
                    <v-btn class="jh-btn is-border-blue" @click="registWord" v-if="this.mixin_set_btn(this.$options.name, 'btnNew')">신규</v-btn>
                    <v-btn class="jh-btn is-light" @click="getWordView" v-if="this.mixin_set_btn(this.$options.name, 'btnDetail')">수정</v-btn>
                    <v-btn class="jh-btn is-del" @click="showDeleteWordConfirm" v-if="this.mixin_set_btn(this.$options.name, 'btnDelete')">삭제</v-btn>
                </div>
            </div>
            <v-data-table
                class="jh-grid"
                height="600px"
                :headers="gridDataHeaders"
                :items="gridDataText"
                :items-per-page="30"
                item-key="PROH_WORD"
                :page.sync="page"
                :item-class="isActiveRow"
                fixed-header
                hide-default-footer
                show-select
                @page-count="pageCount = $event"
                @click:row="setListSel"
                @dblclick:row="showModalInfo"
                v-model="selectedCdList"
                no-data-text="검색된 결과가 없습니다."
            >
            </v-data-table>
            <div class="jh-pager">
                <v-pagination v-model="page" :length="pageCount" :total-visible="totalVisible"></v-pagination>
                <span class="jh-counter is-left">총 <em>{{ gridDataText.length }}</em> 건</span>
            </div>
            
            <!--신규 그리드-->
            <!-- <data-tables
            v-model="selectedCdList"
            dataTableClass=""
            :data-table-options="dataTableOptions"
            @click:row="setListSel"
            @dblclick:row="showModalInfo"
            :paginationOptions="paginationOptions"
            ></data-tables> -->
        </div>
    
        <v-dialog max-width="350" v-if="dialogE020603P01" v-model="dialogE020603P01" :eager="true">
            <dialog-E020603P01
                :searchCustKey = "searchCustKey"
                headerTitle="금칙어 신규생성"
                @hide="hideDialog('E020603P01')"
                @hideAndGetList="hideAndGetList('E020603P01')"
            >
            </dialog-E020603P01>
        </v-dialog>
        <v-dialog max-width="350" v-if="dialogE020603P02" v-model="dialogE020603P02" :eager="true">
            <dialog-E020603P02
                :param="detailData"
                :searchCustKey = "searchCustKey"
                headerTitle="금칙어 상세"
                @hide="hideDialog('E020603P02')"
                @hideAndGetList="hideAndGetList('E020603P02')"
            >
            </dialog-E020603P02>
        </v-dialog>
    </div>
</template>

<script>
import api from '../../store/apiUtil.js'
import DialogE020603P01 from "./E020603P01.vue"
import DialogE020603P02 from "./E020603P02.vue"
import dataTables from "@/components/DataTables";
import { mixin } from "@/mixin/mixin.js"
import {mapGetters} from "vuex";

let jsonObj

export default {
  name: "MENU_E020603", //name은 'MENU_' + 파일명 조합
  mixins: [mixin],
  components: {
    DialogE020603P01,
    DialogE020603P02,
    dataTables
  },
  data: () => ({
    dialogE020603P01: false,
    dialogE020603P02: false,
    searchVo: function (){
      this.SEARCH_PROH_WORD = "" //금칙어명
      this.USE_YN = ""//사용여부
      this.ASP_NEWCUST_KEY = "001"
    },
    formSearchData: {},
    common_code: [],
    selectedCdList: [],
    searchName: "",
    gridDataHeaders: [
      { text: "checkBox", value: "data-table-select", align: "center", width: "30px", sortable: false},
      { text: "No", align: "center", value: "ROWNUM", width: "60px" },
      { text: "금칙어", value: "PROH_WORD", align: "center" },
      { text: "변환어", value: "CHANGE_WORD", align: "center" },
      { text: "등록자명", value: "REG_NM", align: "center", width: "150px" },
      { text: "등록자사번", value: "REG_ID", align: "center", width: "150px" },
      { text: "등록일자", value: "REG_DTTM", align: "center", width: "180px" },
      { text: "수정자명", value: "AMDR_NAME", align: "center", width: "150px" },
      { text: "수정자사번", value: "UPD_ID", align: "center", width: "150px" },
      { text: "수정일자", value: "UPD_DTTM", align: "center", width: "180px" },
      { text: "사용여부", value: "USE_YN", align: "center", width: "100px" }
    ],
    gridDataText: [],
    page: 1,
    pageCount: 0,
    itemsPerPage: 50,
    totalVisible: 10,
    detailData: {},
    selectedRow: [],
    selectedRow2: [],
    isFormValid: true,
    searchCustKey: '',
      useYnDrop: [],

    dataTableOptions: {
        fixedHeader: true,
        hideDefaultFooter: true,
        height: '600px',
        itemKey: 'PROH_WORD',
        itemClass: 'isActiveRow',
        itemsPerPage: 50,
        noDataText: "조회된 결과가 없습니다.",
        page: 1,
        showSelect: true,
    },
    paginationOptions: {
        totalVisible: 10
    },
  }),
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      this.formSearchData = new this.searchVo()

      this.callCommonCode()

      this.detailData = ""
      this.$refs.form.resetValidation()
    },
    async callCommonCode(){
      let codeName = ["TWB001"]
      this.common_code= await this.mixin_common_code_get_all(codeName)
      this.useYnDrop = await this.mixin_common_code_get(this.common_code, 'TWB001', '전체')
      console.log("this.useYnDrop : ", this.useYnDrop)
      this.formSearchData.USE_YN = this.useYnDrop[0].value
    },
    showModalInfo(event, { item }) {
      console.log("item   ", item)
      this.detailData = {}
      this.detailData = item
      this.showDialog("E020603P02");
    },
    setListSel(item, row) {
      this.detailData = item;
    },
    showDialog(type) {
      this[`dialog${type}`] = true;
    },
    hideDialog(type) {
      this[`dialog${type}`] = false;
    },
    result() {
    //   if(this.isEmpty(this.formSearchData.ASP_NEWCUST_KEY)){
    //     this.common_alert('회사구분 은(는) 필수입력입니다.', 'error')
    //     return false
    //   }
      if(!this.$refs.form.validate()) return false
      this.apiCall('L', this.formSearchData)
    },
    setGridText(jsonData) {
      jsonObj = JSON.parse(jsonData);
      this.gridDataText = jsonObj;
    },
    showDeleteWordConfirm(){
      if(this.isEmpty(this.selectedCdList)){
        this.common_alert('체크된 항목이 존재하지 않습니다.', 'error')
        return;
      }
      this.common_confirm('해당 금칙어정보를 삭제하시겠습니까?', this.deleteWord, '', this.closeAlert, '', 'error')
    },
    deleteWord(){

      let deleteList = [];

      for(let i in this.selectedCdList){
        let obj = {
          ASP_NEWCUST_KEY: this.selectedCdList[i].ASP_NEWCUST_KEY,
          PROH_CODE: this.selectedCdList[i].PROH_CODE
        };
        deleteList.push(obj)
      }

      let jsonData = {
        sendData: {
          DATA: deleteList
        }
      };

      this.apiCall('D', jsonData.sendData)
    },
    async apiCall(type, param){

      let URLData = ""
      let HEADER_SERVICE = ""
      let HEADER_TYPE = "BIZ_SERVICE"
      let HEADER_METHOD = ""
      let HEADER_ROW_CNT = 1000;
      let HEADER_PAGES_CNT = 1;

      if(type === 'D'){
        URLData = "/api/chat/setting/banned-word/delete"
        HEADER_SERVICE = "chat.setting.banned-word"
        HEADER_METHOD = "delete"

      }else{
        URLData = "/api/chat/setting/banned-word/list"
        HEADER_SERVICE = "chat.setting.banned-word"
        HEADER_METHOD = "list"
      }

      await api
          .post(URLData, param, {
            head: {
              SERVICE: HEADER_SERVICE,
              METHOD: HEADER_METHOD,
              TYPE: HEADER_TYPE,
              ROW_CNT: HEADER_ROW_CNT,
              PAGES_CNT: HEADER_PAGES_CNT
            },
          })
          .then((response) => {
            if(type === 'D'){
              //삭제
              if(!this.isEmpty(response) && !response.data.HEADER.ERROR_FLAG) {
                this.common_alert('정상처리 되었습니다.', 'done')
                this.selectedRow = [];
                this.detailData = {}
                this.result()
              } else {
                this.common_alert(response.data.HEADER.ERROR_MSG, 'error')
              }
            }else{
              if(!this.isEmpty(this.selectedRow)){
                //초기화
                this.selectedRow = [];
                this.detailData = {}
              }
              //조회
              this.searchCustKey = this.formSearchData.ASP_NEWCUST_KEY
              this.setGridText(JSON.stringify(response.data.DATA));
            }
          })
          .catch((err) => {
            alert(err);
          });

    },
    isEmpty(val) {
      if (val == null) return true
      if (typeof val === 'undefined') return true
      if (typeof val === 'string' && val === '' && (''+val) === '') return true
      if (Array.isArray(val) && val.length < 1) return true
      if (typeof val === 'object' && val.constructor.name === 'Object' && Object.keys(val).length < 1 && Object.getOwnPropertyNames(val) < 1) return true
      if (typeof val === 'object' && val.constructor.name === 'String' && Object.keys(val).length < 1) return true
      if (val.constructor === Object && Object.keys(val).length === 0) return true
    },
    closeAlert(){
      this.$store.commit("alertStore/openAlertDialog", {
        alertDialogToggle: false,
      });
    },
    registWord(){
      if(this.isEmpty(this.formSearchData.ASP_NEWCUST_KEY)){
        this.common_alert('회사구분은(는) 필수 입력입니다.', 'error')
        return false
      }
      this.showDialog("E020603P01")
    },
    hideAndGetList(type){
      this.detailData = {}
      this.selectedCdList = []
      this.hideDialog(type)
      this.result()
    },
    getWordView(){
      if(this.isEmpty(this.detailData)){
        this.common_alert('선택된 항목이 존재하지 않습니다.', 'error')
        return;
      }
      this.showDialog("E020603P02")
    },
    isActiveRow(item){
      return item.PROH_WORD == this.detailData.PROH_WORD? 'is-active':'';
    }
  },
  computed: {
    ...mapGetters({
      userCompany: 'userStore/GE_USER_COMPANY'
    }),
  },
  

  created() { 
        this.dataTableOptions.headers = this.gridDataHeaders;
        this.dataTableOptions.items = this.gridDataText;
    }
};
</script>
<style>


</style>
